var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaperChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-327.000000, -207.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(327.000000, 207.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0.01,
    fillRule: "nonzero",
    height: 22,
    width: 22,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20.1666667 2.29166667 1.83333333 2.29166667 1.83333333 7.79166667 20.1666667 7.79166667",
    stroke: "#212121",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "1.83333333 18.8054625 7.41381667 13.1675958 10.4293292 16.0554625 14.1158417 12.375 16.1694042 14.377",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    strokeLinecap: "round",
    strokeWidth: 1.5,
    x1: 20.1666667,
    x2: 20.1666667,
    y1: 7.41212083,
    y2: 19.3287875
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#212121",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    x1: 1.83333333,
    x2: 1.83333333,
    y1: 7.41212083,
    y2: 13.8287875
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#212121",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    x1: 5.96548333,
    x2: 20.1667125,
    y1: 19.7083333,
    y2: 19.7083333
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#212121",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    x1: 7.79166667,
    x2: 17.4166667,
    y1: 5.04166667,
    y2: 5.04166667
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#212121",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    x1: 4.58333333,
    x2: 5.04166667,
    y1: 5.04010833,
    y2: 5.04010833
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperChart);
export default __webpack_public_path__ + "static/media/paper-chart.9866ae87d4ac130d84ee1a6b7ce57d6a.svg";
export { ForwardRef as ReactComponent };